import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 流拍撮合选择
Mock.mock(/\/auctions\/auction_cars\/\d+\/matchable_auctions/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'matchable_auctions': [
      {
        'auction_id': 10,
        'maximum_price': 1234500, // 最高价，单位分
        'bidders_count': 12, // 出价人数
        'bids_count': 100, // 出价次数
        'finished_at': '2018-5-24 12:00:21' // 撮合结束时间
      },
      {
        'auction_id': 11,
        'maximum_price': 2234500, // 最高价，单位分
        'bidders_count': 5, // 出价人数
        'bids_count': 20, // 出价次数
        'finished_at': '2018-5-24 12:00:21' // 撮合结束时间
      }
    ]
  }
})

// 询价撮合选择
Mock.mock(/\/auctions\/auction_cars\/\d+\/matchable_enquiries/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'matchable_enquiries': [
      {
        'enquiry_id': 10,
        'maximum_price': 1234500, // 最高报价价，单位分
        'quote_count': 5, // 报价人数
        'finished_at': '2018-5-24 12:00:21' // 撮合结束时间
      },
      {
        'enquiry_id': 11,
        'maximum_price': 3234500, // 最高报价价，单位分
        'quote_count': 16, // 报价人数
        'finished_at': '2018-5-24 12:00:21' // 撮合结束时间
      }
    ]
  }
})
